import { getAppConfigSingleton } from "@expert/app-config";
import type { Partner } from "@expert/shared-types";

export function isDeviceActivationCall({
    partner,
    supportNumberCalled,
    queueName,
}: {
    partner: Partner;
    supportNumberCalled?: string;
    queueName?: string;
}) {
    if (!supportNumberCalled && !queueName) return false;

    const partnerConfig = getAppConfigSingleton().getPartnersConfig;
    const partnerConfigInfo = partnerConfig(partner);
    return (
        (supportNumberCalled && partnerConfigInfo.activationSupportNumbers?.includes(supportNumberCalled)) ||
        (queueName && partnerConfigInfo.activationSupportQueues?.includes(queueName))
    );
}

export function isDeviceActivationIntent(intent?: string) {
    return intent?.toLowerCase() === "device activation";
}
